import { baseApi } from '../baseApi';
import { PersonModel } from '../../models/personModel';
import { cleanObject } from '../../utils/objectUtils';

export async function getPersonalDetailsReq() {
  let url = '/officiating/person/personal';
  return baseApi.get<PersonModel>(url);
}

export async function getPersonalDetailsByIdReq(personId: string) {
  let url = '/officiating/person/personal/other?';
  let queryParamsObj = cleanObject({
    personId,
  });

  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get<PersonModel>(url + queryParams);
}

export async function updatePersonalDetailsReq(profile: PersonModel, image?: File) {
  const data = new FormData();
  if (image) data.append('file', image);
  data.append('profile', JSON.stringify(profile));
  return baseApi.put('/officiating/person/personal', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
